import React from 'react';
import { useAuth } from '../../../context/AuthContext';
import AuthorizeConnectCard from '../../../authorize/components/AuthorizeConnectCard';
import BackToPaymentSettings from '../components/BackToPaymentSettings';

const AuthorizeSettings = ({ onBackToPayments }) => {
  const { companyData, user } = useAuth();
  const isSpecialAdmin = !!user?.isSpecialAdmin;

  return (
    <div className="authorize-settings-page">
      {onBackToPayments && <BackToPaymentSettings onBack={onBackToPayments} />}
      <AuthorizeConnectCard
        companyId={companyData?.id}
        isSpecialAdmin={isSpecialAdmin}
      />
    </div>
  );
};

export default AuthorizeSettings;
